import React, { useState, useEffect } from "react";
import { Button, Spinner, Table, Form, Card } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { TeamRole } from "../../../../../types/ITeam";
import { useAuth } from "../../../../../utils/hooks/useAuth";
import {
  saveTeamState,
  fetchTeam,
  teamsSelector,
} from "../../_redux/teamsSlice";

interface MemberTableProps {
  intl: any;
}

const MemberTable: React.FC<MemberTableProps> = ({
  intl,
}: MemberTableProps) => {
  const dispatch = useDispatch();
  const { userId } = useAuth();
  const { currentTeam, saveTeamStateInProgress } = useSelector(teamsSelector);

  const [members, setMembers] = useState(currentTeam.members);
  const [isAdmin, setIsAdmin] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [isDisableSubmitButton, setIsDisableSubmitButton] = useState(true);

  useEffect(() => {
    const _isAdmin = currentTeam.members.some(
      (m) => m.userId === userId && m.teamRole === TeamRole.ADMIN
    );
    setIsAdmin(_isAdmin);
    setMembers(currentTeam.members);
  }, [currentTeam]);

  useEffect(() => {
    if (hasChanged) {
      setIsDisableSubmitButton(false);
    }
  }, [hasChanged]);

  useEffect(() => {
    if (saveTeamStateInProgress) {
      setIsDisableSubmitButton(saveTeamStateInProgress);
      setHasChanged(false);
    }
  }, [saveTeamStateInProgress]);

  const handleSaveTeamRoles = async () => {
    const payload = {
      members: members,
    };
    await dispatch(saveTeamState(currentTeam.id, payload));
    dispatch(fetchTeam(currentTeam.id));
  };

  const handleChange = (userId, teamRole) => {
    setHasChanged(true);
    setMembers(
      members.map((member) =>
        member.userId == userId ? { ...member, teamRole: teamRole } : member
      )
    );
  };

  return (
    <Card>
      <Card.Body>
        <Table hover className="m-0">
          <thead>
            <tr>
              <th>
                <FormattedMessage id="TEAM.MEMBER.TABLE.USER_NAME" />
              </th>
              <th>
                <FormattedMessage id="TEAM.MEMBER.TABLE.EMAIL" />
              </th>
              <th>
                <FormattedMessage id="TEAM.MEMBER.TABLE.TEAM_ROLE" />
              </th>
            </tr>
          </thead>
          <tbody>
            {members ? (
              members.map((m) => (
                <tr>
                  <th>{m.name}</th>
                  <th>{m.email}</th>
                  <td>
                    {isAdmin ? (
                      <select
                        className="form-control form-control-solid"
                        value={m.teamRole}
                        onChange={(e) => handleChange(m.userId, e.target.value)}
                      >
                        <option value="admin">
                          {intl.formatMessage({ id: "TEAM.MEMBER.ROLE.ADMIN" })}
                        </option>
                        <option value="member">
                          {intl.formatMessage({ id: "TEAM.MEMBER.ROLE.USER" })}
                        </option>
                      </select>
                    ) : (
                      m.teamRole
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <></>
            )}
          </tbody>
        </Table>
        {isAdmin ? (
          <Button
            variant="primary"
            as="input"
            type="button"
            value={
              saveTeamStateInProgress
                ? intl.formatMessage({ id: "COMMON.SUBMITTING_BUTTON" })
                : intl.formatMessage({ id: "COMMON.SUBMIT_BUTTON" })
            }
            className="w-100px"
            onClick={handleSaveTeamRoles}
            disabled={isDisableSubmitButton}
          />
        ) : (
          <></>
        )}
      </Card.Body>
    </Card>
  );
};

export default injectIntl(MemberTable);
